/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
export const redefinePublicPath = () => {
  // We don't support setting public path in webpack via NPM build.
};